module.exports = __webpack_public_path__ + "mars-ai-blue-2e673b17.png";